// extracted by mini-css-extract-plugin
export default {"Box":"filter-counter-label-module__Box__AbB0fLG"};